import { useAuthContext } from '../../context';
import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export default function useFetchInvitation() {
  const { currentUser } = useAuthContext();
  const { queryFn, queryKey } = queryKeys.invitations.fetchInvitationByUserId();

  return useQuery({
    enabled: currentUser?.status === 'ACTIVE',
    queryFn,
    queryKey,
  });
}
